import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { currentLocationModulesSelector } from 'state/ducks/auth'

const ReportsModuleConditional = ({ children, fallbackComponent }) => {
  const hasPermissions = (useSelector(currentLocationModulesSelector) || {}).canViewReports

  if (hasPermissions) return <>{children}</>

  if (fallbackComponent) return fallbackComponent

  return null
}

ReportsModuleConditional.propTypes = {
  children: PropTypes.element.isRequired,
  fallbackComponent: PropTypes.element,
}

ReportsModuleConditional.defaultProps = {
  fallbackComponent: undefined,
}

export default ReportsModuleConditional
